import { render, staticRenderFns } from "./c_home_article.vue?vue&type=template&id=110ee2aa&scoped=true"
import script from "./c_home_article.vue?vue&type=script&lang=js"
export * from "./c_home_article.vue?vue&type=script&lang=js"
import style0 from "./c_home_article.vue?vue&type=style&index=0&id=110ee2aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110ee2aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('110ee2aa')) {
      api.createRecord('110ee2aa', component.options)
    } else {
      api.reload('110ee2aa', component.options)
    }
    module.hot.accept("./c_home_article.vue?vue&type=template&id=110ee2aa&scoped=true", function () {
      api.rerender('110ee2aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_article.vue"
export default component.exports